var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[_c('div',{staticClass:"progress-bar"},[_c('v-progress-circular',{attrs:{"size":40,"color":"primary","indeterminate":""}})],1),_c('div',{ref:"mapRef",staticClass:"g-map"})])}
var staticRenderFns = []

export { render, staticRenderFns }